import React from 'react'
import { graphql, Link, useStaticQuery } from 'gatsby'
import tw, { styled } from 'twin.macro'
import PropTypes from 'prop-types'

const Wrapper = styled.div`
	${tw`flex flex-col gap-16 pt-4 pb-12 px-4 bg-white`}
`

const Section = styled.section`
	${tw`flex flex-col items-center`}
`

const Heading = styled.h2`
	${tw`text-black font-black text-center mb-3`}
	font-weight: 800;
	font-size: clamp(1.4rem, 3vw, 2.8rem);
	font-family: Flexo, system-ui, sans-serif !important;
`

const Subheading = styled.p`
	${tw`text-black text-center max-w-xl mb-10 font-semibold`}
	font-size: clamp(0.9rem, 1.3vw, 1rem);
	line-height: 1.6;
`

const TileGrid = styled.div`
	${tw`flex flex-col md:flex-row w-full`}
	gap: 40px;
	max-width: 1100px;
`

const Tile = styled.div`
	${tw`relative flex flex-col overflow-hidden flex-1`}
	min-height: 300px;
	border-radius: 45px;
	background-size: cover;
	background-position: center;
	background-repeat: no-repeat;
	padding: 2rem;

	@media (min-width: 768px) {
		min-height: 420px;
	}
`


const TileContent = styled.div`
	${tw`relative flex flex-col justify-end flex-1`}
	min-height: inherit;
`

const TileBottom = styled.div`
	${tw`flex justify-center`}
`

const TileButton = styled(Link)`
	${tw`font-semibold px-6 py-2 cursor-pointer inline-flex items-center gap-2`}
	background: transparent;
	color: white;
	border: 2px solid white;
	border-radius: 9999px;
	font-size: 0.9rem;
	text-decoration: none;

	&::after {
		content: '→';
	}
`

const ExploreTwoTile = ({ locale }) => {
	const data = useStaticQuery(ExploreTwoTileQuery)
	const mLine = data.MLineBanner?.nodes[0]
	const sLine = data.SLineBanner?.nodes[0]
	const liberty = data.LibertyBanner?.nodes[0]
	const eon = data.EonBanner?.nodes[0]

	return (
		<Wrapper>
			<Section>
				<Heading>Dolphin Corded Robotic Pool Cleaners</Heading>
				<Subheading>
					Dolphin Corded Robotic Pool Cleaners deliver powerful, uninterrupted
					cleaning with constant power and consistent suction.
				</Subheading>
				<TileGrid>
					<Tile style={{ backgroundImage: `url(${mLine?.backgroundImage?.fluid?.src})` }}>
						<TileContent>
							<TileBottom>
								<TileButton to={'/' + mLine?.mainActionUrl}>{mLine?.mainActionText}</TileButton>
							</TileBottom>
						</TileContent>
					</Tile>
					<Tile style={{ backgroundImage: `url(${sLine?.backgroundImage?.fluid?.src})` }}>
						<TileContent>
							<TileBottom>
								<TileButton to={'/' + sLine?.mainActionUrl}>{sLine?.mainActionText}</TileButton>
							</TileBottom>
						</TileContent>
					</Tile>
				</TileGrid>
			</Section>

			<Section>
				<Heading>Dolphin Cordless Robotic Pool Cleaners</Heading>
				<Subheading>
					Experience the freedom of cordless cleaning with advanced battery-powered
					robots designed for convenience and efficiency.
				</Subheading>
				<TileGrid>
					<Tile style={{ backgroundImage: `url(${liberty?.backgroundImage?.fluid?.src})` }}>
						<TileContent>
							<TileBottom>
								<TileButton to={'/' + liberty?.mainActionUrl}>{liberty?.mainActionText}</TileButton>
							</TileBottom>
						</TileContent>
					</Tile>
					<Tile style={{ backgroundImage: `url(${eon?.backgroundImage?.fluid?.src})` }}>
						<TileContent>
							<TileBottom>
								<TileButton to={'/' + eon?.mainActionUrl}>{eon?.mainActionText}</TileButton>
							</TileBottom>
						</TileContent>
					</Tile>
				</TileGrid>
			</Section>
		</Wrapper>
	)
}

export const ExploreTwoTileQuery = graphql`
	query ExploreTwoTileQuery {
		MLineBanner: allContentfulBanner(
			filter: { contentful_id: { eq: "3HQ2mMZx0XDD6mqdx7CZ8q" }, node_locale: { eq: "en-AU" } }
		) {
			nodes {
				backgroundImage {
					fluid(maxWidth: 1920, quality: 80) {
						...GatsbyContentfulFluid_withWebp
					}
				}
				mainActionText
				mainActionUrl
				hook
			}
		}

		SLineBanner: allContentfulBanner(
			filter: { contentful_id: { eq: "6QMafAck77iiXeRKuODDp7" }, node_locale: { eq: "en-AU" } }
		) {
			nodes {
				backgroundImage {
					fluid(maxWidth: 1920, quality: 80) {
						...GatsbyContentfulFluid_withWebp
					}
				}
				mainActionText
				mainActionUrl
				hook
			}
		}

		LibertyBanner: allContentfulBanner(
			filter: { contentful_id: { eq: "1NlFt25kaflEB9FoaaUPxD" }, node_locale: { eq: "en-AU" } }
		) {
			nodes {
				backgroundImage {
					fluid(maxWidth: 1920, quality: 80) {
						...GatsbyContentfulFluid_withWebp
					}
				}
				mainActionText
				mainActionUrl
				hook
			}
		}

		EonBanner: allContentfulBanner(
			filter: { contentful_id: { eq: "75ZGG3QqQ7DyFypA6EvgaM" }, node_locale: { eq: "en-AU" } }
		) {
			nodes {
				backgroundImage {
					fluid(maxWidth: 1920, quality: 80) {
						...GatsbyContentfulFluid_withWebp
					}
				}
				mainActionText
				mainActionUrl
				hook
			}
		}
	}
`

ExploreTwoTile.propTypes = {
	locale: PropTypes.string.isRequired,
}

export default ExploreTwoTile
